import AuthApi from "common/api/auth";
import CampaignApi from "common/api/campaign";
import ContactApi from "common/api/contact";
import PaymentApi from "common/api/payment";
import PerformanceApi from "common/api/performance";
import SuggestionApi from "common/api/suggestion";
import WizardApi from "common/api/wizard";
import SettingApi from "common/api/setting";
import AnalyticsApi from "common/api/analytics";
import SalesdeskApi from "common/api/salesdesk";
import GoogleApi from "common/api/google";
import FacebookApi from "common/api/facebook";
import MainApi from "common/api/main";
import BusinessApi from "common/api/business";
import RCRMApi from "common/api/rcrm";

export default {
  ...AuthApi,
  ...CampaignApi,
  ...ContactApi,
  ...PaymentApi,
  ...PerformanceApi,
  ...SuggestionApi,
  ...WizardApi,
  ...SettingApi,
  ...AnalyticsApi,
  ...SalesdeskApi,
  ...GoogleApi,
  ...FacebookApi,
  ...MainApi,
  ...BusinessApi,
  ...RCRMApi,
};
